const dropdown = {
  init: function() {
    const me = this;
    const containers = document.querySelectorAll('.dropdown');

    Array.prototype.forEach.call(containers, (container, index) => {
      me.bind(container);
    })
  },
  bind: function(container)  {
    const buttons = container.querySelectorAll('.dropdown__btn');
    const selector = container.querySelector('.dropdown__select');
    const dropdownItems = container.querySelectorAll('li');
    const dropdownList = container.querySelector('ul');
    if (dropdownList) {
      container.addEventListener('click', (e) => {
        e.preventDefault();
        this.addSelected(selector, dropdownItems);
        container.classList.toggle('dropdown--show');
        Array.prototype.forEach.call(dropdownItems, (item, index) => {
          if (item.id === selector.id) {
            item.classList.add('dropdown--selected');
          }
        })
      })
      Array.prototype.forEach.call(dropdownItems, (item, index) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          selector.id = item.id;
          selector.innerHTML = item.innerHTML;
          Array.prototype.forEach.call(dropdownItems, (item, index) => {
            item.classList.remove('dropdown--selected');
          })
        })
      })
    }
  },
  addSelected: function (selector, items) {
    Array.prototype.forEach.call(items, (item, index) => {
      if (item.id === selector.id) {
        item.classList.toggle('dropdown--selected');
      }
    })
  }
};

dropdown.initialize = () => {
  dropdown.init();
};

module.exports = dropdown;